import React from 'react';
import { motion } from 'framer-motion';

const CutoutButton = ({ label = 'All Cases', onClick, className = '' }) => {
  return (
    <motion.button
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3, duration: 0.5 }}
      onClick={onClick}
      className={`group flex items-center gap-3 pl-7 pr-1 py-1 bg-white text-black rounded-full font-bold text-sm hover:bg-white/90 transition-all duration-300 ${className}`}
    >
      {label}
      <div className="w-10 h-10 bg-black rounded-full flex items-center justify-center transition-transform group-hover:scale-110">
        <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M7 17L17 7M17 7H7M17 7V17"
          />
        </svg>
      </div>
    </motion.button>
  );
};

export default CutoutButton;
